import { Drawer } from '@mui/material';
import { PropsWithChildren } from 'react';

type IntakeDrawerProps = {
  isOpen: boolean;
  handleCloseDrawer: () => void;
};

export const IntakeDrawer = ({ children, isOpen, handleCloseDrawer }: PropsWithChildren<IntakeDrawerProps>) => {
  return (
    <Drawer
      anchor="right"
      hideBackdrop
      open={isOpen}
      sx={{ pointerEvents: 'none' }}
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          handleCloseDrawer();
        }
      }}
      slotProps={{
        paper: {
          sx: {
            width: 420,
            pointerEvents: 'auto',
            borderRadius: '12px 0 0 12px',
            boxShadow:
              '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
          },
        },
      }}
    >
      {children}
    </Drawer>
  );
};
